import React from "react";
import PropTypes from "prop-types";
import FontAwesome from "react-fontawesome";
import AdminTitle from "../../components/AdminTitle";
import Api from "../../Api";
import "./AdminCollections.less";
import {Link} from "react-router";

export default class AdminCollections extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      collectionsResponse: null,
      error: null
    };
  }

  componentDidMount() {
    this.refreshCollections();
  }

  createCollection() {
    let newCollection = { name: 'New product collection' };
    Api.createOrUpdateProductCollection(newCollection).then(
      (createdProductCollection) => {
        this.context.router.push(`/admin/collections/${createdProductCollection.token}`);
      },
      (error) => {
        this.setState({error});
      }
    );
  }

  refreshCollections() {
    Api.getProductCollections().then(
      (collectionsResponse) => {
        this.setState({
          collectionsResponse: collectionsResponse
        });
      },
      (error) => {
        this.setState({error});
      }
    );
  }

  render() {
    if (this.state.error) {
      console.error(this.state.error);
      return (<div className="error">Error: {this.state.error.message}</div>);
    }

    let collectionsList;
    let header;
    if (!this.state.collectionsResponse) {
      collectionsList = <FontAwesome name="refresh" spin/>;
    } else {
      header = (
        <div key="header" className="collection-list-entry">
          <span className="active">Active?</span>
          <span className="items">Items</span>
          <span className="name">Name</span>
          <span className="description">Description</span>
        </div>
      );

      collectionsList = this.state.collectionsResponse.product_collections.map((collection) => {
        let token = collection.token;
        let activeClass = "active " + (collection.active ? "fa fa-check" : "");
        let items = collection.items ? collection.items.length : 0;
        let name = collection.name || '';
        let description = collection.description || '';

        return (
          <Link key={`edit-${token}`} to={`/admin/collections/${token}`}>
            <div key={token} className="collection-list-entry">
              <span className={activeClass}/>
              <span className="items">{items}</span>
              <span className="name">{name}</span>
              <span className="description">{description}</span>
            </div>
          </Link>
        );
      });
    }

    return (
      <div className="collection-list">
        <AdminTitle title="Product Collections">
          <input type="button" className="button button--small"
                 onClick={this.createCollection.bind(this)} value="Create Collection"/>
        </AdminTitle>
        {header}
        {collectionsList}
      </div>
    );
  }
}

AdminCollections.contextTypes = {
  router: PropTypes.object
};



/** WEBPACK FOOTER **
 ** ./src/views/admin/AdminCollections.js
 **/